import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Grid, TextField, Typography, Button, FormControlLabel, Checkbox, Select, FormControl, InputLabel, FormLabel, RadioGroup, Radio } from '@material-ui/core';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { getCostCenter } from 'context/express/actions';
import { I18nContext } from 'translations';
import AutocompleteInput from 'components/CustomInputs/AutocompleteInput';
import ModalMap from 'components/Modals/ModalMap';
import ReservationsOptions from './Reservations';
import { PIBOX_CAR_SERVICE_TYPE_ID, SERVICE_TYPE_CAR_RENT, SERVICE_TYPE_ID, COUNTRY_LANGUAJE } from 'utils/constants';

const OriginFields = ({
  origin,
  handleSuggest,
  register,
  city,
  type,
  changeCoord,
  loadingAproxAddress,
  Controller,
  control,
  company,
  vehicleTypes,
  listVehicles,
  loadingServiceTypes,
  counterDelivery,
  driverWithMoneyBalance,
  isRent,
  availableServiceType,
  favoritesAsOrigins,
  moneyBalance,
  canCreateReservation,
  listReservations,
  bookingReservationId,
  selectedPrincipalBooking,
  openModalServiceDriver,
  setOpenModalServiceDriver
}) => {
  const { translate, langCode } = useContext(I18nContext);
  const isColombiaMarket = COUNTRY_LANGUAJE[company?.geo_fence_id] === 'es' || langCode === 'es';
  const [open, setOpen] = useState(false);
  const [costCenter, setCostCenter] = useState([]);
  const [hasLoadedOriginVehicleType, setHasLoadedOriginVehicleType] = useState(false);
  const handleModalMap = () => setOpen(!open);

  const listCostCenter = useCallback(async () => {
    const callback = company && await getCostCenter(company._id);
    callback && callback.costCenter && setCostCenter(callback.costCenter);
  }, [company])

  useEffect(() => {
    listCostCenter();
  }, [listCostCenter])

  useEffect(() => {
    if (origin?.vehicle_types && !hasLoadedOriginVehicleType) {
      control.setValue('vehicle_types', origin.vehicle_types);
      setHasLoadedOriginVehicleType(true);
    }
    if (!origin?.vehicle_types && hasLoadedOriginVehicleType) {
      setHasLoadedOriginVehicleType(false);
    }
  }, [origin?.vehicle_types, hasLoadedOriginVehicleType, control]) // eslint-disable-line

  const cargoVehicles = isColombiaMarket
    ? (listVehicles?.filter(s => s._id !== SERVICE_TYPE_ID && s._id !== PIBOX_CAR_SERVICE_TYPE_ID) || null)
    : null;
  const hasCarService = isColombiaMarket
    ? (listVehicles?.some(s => s._id === PIBOX_CAR_SERVICE_TYPE_ID) || false)
    : false;
  const loadVehicles = vehicleTypes === 'cargo'
    ? (isColombiaMarket ? cargoVehicles : listVehicles)
    : null;
  if (city.lat !== 0) {
    return (
      <Grid item container justify="center" alignItems="flex-start" spacing={2}>
        {listReservations && listReservations.length > 0 && (
          <ReservationsOptions
            listReservations={listReservations}
            bookingReservationId={bookingReservationId}
            setOpenModalServiceDriver={setOpenModalServiceDriver}
            selectedPrincipalBooking={selectedPrincipalBooking}
            openModalServiceDriver={openModalServiceDriver}
          />
        )}
        {company && !isRent &&
          <Grid item md={12} sm={12} xs={12}>
            <FormControl variant="outlined" fullWidth size="small">
              <InputLabel>
                {translate('app.express.typeOfService')}
              </InputLabel>
              <Controller
                name="vehicle_types"
                control={control}
                defaultValue={origin?.vehicle_types || (availableServiceType?.some(t => t === 'pibox') ? 'moto' : '')}
                render={({ onChange, value }) => (
                  <Select
                    native
                    label={translate('app.express.typeOfService')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={value}
                    onChange={onChange}
                    disabled={isColombiaMarket && loadingServiceTypes}
                  >
                    {isColombiaMarket
                      ? <option value='moto'>{translate('typeOfService.express')}</option>
                      : availableServiceType?.map((type) => (
                          type === 'pibox' ? <option key='moto' value='moto'>{translate('typeOfService.express')}</option> : null
                        ))
                    }
                    {isColombiaMarket
                      ? (cargoVehicles?.length > 0 && !isRent && <option value='cargo'>{translate('app.express.vehicleType.cargo')}</option>)
                      : (availableServiceType?.some(t => t === 'freight') && !isRent && <option value='cargo'>{translate('app.express.vehicleType.cargo')}</option>)
                    }
                    {isColombiaMarket
                      ? (hasCarService && <option value={PIBOX_CAR_SERVICE_TYPE_ID}>{translate('app.express.vehicleType.car')}</option>)
                      : <option value={PIBOX_CAR_SERVICE_TYPE_ID}>{translate('app.express.vehicleType.car')}</option>
                    }
                  </Select>
                )}
              />
            </FormControl>
            {loadVehicles && loadVehicles.length > 0 &&
              <FormControl variant="outlined" fullWidth size="small" style={{ marginTop: 18 }}>
                <InputLabel>
                  {translate('app.express.selectVehicle')}
                </InputLabel>
                <Select
                  native
                  inputRef={register}
                  label={translate('app.express.selectVehicle')}
                  name="vehicle"
                  variant="outlined"
                  fullWidth
                  size="small"
                  defaultValue={origin?.requested_service_type_id ? origin.requested_service_type_id : ''}
                >
                  {loadVehicles.map((vehicle =>
                    <option key={vehicle._id} value={vehicle._id}>
                      {vehicle.name.replace(/^Carga\s+/i, '')}
                    </option>
                  ))}
                </Select>
              </FormControl>
            }
          </Grid>
        }
        {canCreateReservation && !isRent && !bookingReservationId &&(
          <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
            <FormControlLabel
              control={
                <Controller
                  name="reservations"
                  defaultValue={false}
                  control={control}
                  render={(props) => (
                    <Checkbox
                      icon={<RadioButtonUncheckedIcon fontSize="small" />}
                      checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                      {...props}
                      checked={props.value}
                      onChange={(e) => props.onChange(e.target.checked)}
                    />
                  )}
                />
              }
              label={translate('app.express.reservationByHours')}
            />
          </Grid>
        )}
        <Grid item md={12} sm={6} xs={12}>
          <AutocompleteInput
            title={translate('app.express.address')}
            name="address"
            address={origin && origin}
            cityId={city.id}
            pos={{ lat: city.lat, lon: city.lon }}
            focus
            handleChange={(info) => handleSuggest(info, 0, 0)}
            disabled={favoritesAsOrigins}
          />
          {!favoritesAsOrigins && <Typography
            color="textSecondary"
            variant="caption"
            className="line-height-xs"
          >
            {translate('app.express.selectAddressFromTheListOfSuggestions')}
            <Button type="button" size="small" onClick={handleModalMap} color="primary" style={{ fontSize: '0.75rem', padding: '0px 5px' }}>
              {translate('app.express.help')}
            </Button>
          </Typography>}
        </Grid>
        <Grid item md={12} sm={6} xs={12}>
          <TextField
            type="text"
            name="secondary_address"
            variant="outlined"
            label={translate('app.express.supplementaryAddress')}
            fullWidth
            inputRef={register}
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        {!driverWithMoneyBalance && !isRent && (
          <>
          <Grid item xs={12} style={{ paddingTop: 0 }}>
            <FormControlLabel
              control={
                <Controller
                  name="requires_a_driver_with_base_money"
                  defaultValue={counterDelivery || false}
                  control={control}
                  render={(props) => (
                    <Checkbox
                      icon={<RadioButtonUncheckedIcon fontSize="small" />}
                      checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                      {...props}
                      checked={props.value}
                      onChange={(e) => props.onChange(e.target.checked)}
                    />
                  )}
                />
              }
              label={translate('app.express.driverHaveToPayProductCollected')}
            />
          </Grid>
          {moneyBalance &&
            <Grid item xs={12} style={{ paddingTop: 0 }}>
              <TextField
                name="money_to_pay_for_package"
                label={translate('app.express.amountToBePaid')}
                variant="outlined"
                size="small"
                type="text"
                defaultValue={0}
                fullWidth
                inputRef={register({
                  pattern: {
                    value: /^[0-9]+$/,
                    message: translate('onlyNumbers'),
                  },
                })}
              />
            </Grid>
          }
          </>
        )}
        {costCenter && costCenter.length > 0 && (
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth size="small">
              <InputLabel>
                {translate('app.bookings.costCenter')}
              </InputLabel>
              <Select
                native
                inputRef={register}
                label={translate('app.bookings.costCenter')}
                name="cost_center_id"
                variant="outlined"
                fullWidth
                size="small"
                defaultValue={costCenter[0]._id}
              >
                {costCenter.map(center => (
                  <option key={center._id} value={center._id}>
                    {center.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {isRent && (
          <Grid item xs={12}>
            <FormControl style={{ marginBottom: 10 }}>
              <FormLabel component="legend" style={{ margin: '10px 0' }}>
                <b>{translate('app.express.vehicleType')}</b><br />
              </FormLabel>
              <Controller
                control={control}
                name="vehicle_types"
                defaultValue={SERVICE_TYPE_ID}
                as={
                  <RadioGroup row>
                    <FormControlLabel value={SERVICE_TYPE_ID} control={<Radio size="small" />} label={translate('app.express.vehicleType.motorcycle')} />
                    <FormControlLabel value={SERVICE_TYPE_CAR_RENT} control={<Radio size="small" />} label={translate('app.express.vehicleType.car')} />
                  </RadioGroup>
                }
              />
            </FormControl>
          </Grid>
        )}
        {open && (
          <ModalMap
            open={open}
            handleModalMap={handleModalMap}
            city={city}
            changeAddress={changeCoord}
            address={origin}
            type={type}
            loadingAproxAddress={loadingAproxAddress}
          />
        )}
      </Grid>
    )
  } else {
    return (
      <Typography
        color="primary"
        style={{ margin: 'auto' }}
      >
        {translate('app.express.chooseACityToCreateAPiboxExpress')}
      </Typography>
    )
  }
}

function areEqual(prevProps, nextProps) {
  return prevProps.origin === nextProps.origin
    && prevProps.register === nextProps.register
    && prevProps.loadingAproxAddress === nextProps.loadingAproxAddress
    && prevProps.driverWithMoneyBalance === nextProps.driverWithMoneyBalance
    && prevProps.moneyBalance === nextProps.moneyBalance
    && prevProps.vehicleTypes === nextProps.vehicleTypes
    && prevProps.listVehicles === nextProps.listVehicles
    && prevProps.loadingServiceTypes === nextProps.loadingServiceTypes
    && prevProps.listReservations === nextProps.listReservations
    && prevProps.bookingReservationId === nextProps.bookingReservationId
    && prevProps.selectedPrincipalBooking === nextProps.selectedPrincipalBooking
}

export default React.memo(OriginFields, areEqual);